(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["aw-header-dropdown-menu"] && !Shopify.designMode) return;
  try {
    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    document.querySelectorAll('.aw-header__inline-menu details').forEach((details) => {
      let closeTimer;

      details.addEventListener('mouseenter', () => {
        clearTimeout(closeTimer);
        details.open = true;
      });

      details.addEventListener('mouseleave', () => {
        closeTimer = setTimeout(() => {
          details.open = false;
        }, 100);
      });
    });
  }
  } catch(e) { console.error(e); }
})();

})();
